import {useMutation} from '@tanstack/react-query';

import {uploadAdminFile, UploadAdminFileParams} from '../api';

export const useUploadAdminFile = () => {
  return useMutation({
    mutationFn: (params: UploadAdminFileParams) => uploadAdminFile(params),
  });
};
